import React, {Component} from 'react';
import {Link, Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import Dashboard from '../../views/Dashboard/';
import AdminDB from '../../views/Dashboard/AdminDB';
import FieldMasterData from '../../views/Dashboard/FieldMasterData';
import EmailSender from '../../views/Dashboard/EmailSender';
import ReportIssue from '../../views/Dashboard/ReportIssue';
import Documentation from '../../views/Dashboard/Documentation';
import UploadImage from '../../views/Dashboard/UploadImage';

import UserList from '../../views/Users/List';
import UserDetail from '../../views/Users/Detail';
import ImportUsers from '../../views/Users/Import';

import ContractorList from '../../views/Contractors/List';
import ContractorDetail from '../../views/Contractors/Detail';
import ImportContractors from '../../views/Contractors/Import';
import ContractorTicketList from '../../views/Contractors/TicketList';

import ProjectList from '../../views/Projects/List';
import ImportProjects from "../../views/Projects/Import";
import ProjectDetail from "../../views/Projects/Detail";

import ProductList from '../../views/Product/List';
import ImportProduct from "../../views/Product/Import";
import ProductDetail from "../../views/Product/Detail";

import BiddingList from "../../views/Bidding/List";
import BiddingDetail from "../../views/Bidding/Detail";

import ContactList from "../../views/Contacts/List";
import ImportContact from "../../views/Contacts/Import";
import ContactDetail from "../../views/Contacts/Detail";

import OrderList from '../../views/Shop/OrderList';
import OrderDetail from '../../views/Shop/OrderDetail';

import MemberShip from '../../views/Master/MemberShip';

import TicketDetail from '../../views/Ticket/TicketDetail';

import AnswerList from '../../views/Projects/AnswerList';
import AnswerDetail from '../../views/Projects/AnswerDetail';
import SlideShop from '../../views/Other/SlideShop';


import Tutorials from '../../views/Tutorials/Tutorials';

import SystemNotification from '../../views/Dashboard/SystemNotification';

class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard}/>
                <Route path="/admin-db" name="AdminDB" component={AdminDB}/>
                <Route path="/field-master-data" name="Fied Master Data" component={FieldMasterData}/>
                <Route path="/email-sender" name="Email Sender" component={EmailSender}/>
                <Route path="/report-issue" name="Report Issue" component={ReportIssue}/>
                <Route path="/docs" name="Docs" component={Documentation}/>
                <Route path="/upload-file" name="Upload File" component={UploadImage}/>

                <Route path="/users/list" name="User List" component={UserList}/>
                <Route path="/user/:id" name="User Profile" component={UserDetail}/>
                <Route path="/users/import" name="Import Users" component={ImportUsers}/>

                <Route path="/contractors/list" name="Contractor List" component={ContractorList}/>
                <Route path="/contractor/:id" name="Contractor Profile" component={ContractorDetail}/>
                <Route path="/contractors/import" name="Import Contractors" component={ImportContractors}/>
                <Route path="/contractors/list-ticket" name="Contractor Ticket List" component={ContractorTicketList}/>

                <Route path="/projects/list" name="Project List" component={ProjectList}/>
                <Route path="/projects/import" name="Import Projects" component={ImportProjects}/>
                <Route path="/project/:id" name="Project Detail" component={ProjectDetail}/>

                <Route path="/bidding/list" name="List" component={BiddingList}/>
                <Route path="/bidding/:id" name="Bidding Detail" component={BiddingDetail}/>

                <Route path="/contacts/list" name="User List" component={ContactList}/>
                <Route path="/contacts/import" name="Import Users" component={ImportContact}/>
                <Route path="/contacts/:id" name="Contact Detail" component={ContactDetail}/>

                <Route path="/products/list" name="Product List" component={ProductList}/>
                <Route path="/product/import" name="Import Product" component={ImportProduct}/>
                <Route path="/product/:id" name="Product Detail" component={ProductDetail}/>

                <Route path="/orders/list" name="Order List" component={OrderList} />
                <Route path="/order/:id" name="Orders Detail" component={OrderDetail} />

                <Route path="/master/membership" name="Membership" component={MemberShip} />

                <Route path="/ticket/:id" name="Ticket Detail" component={TicketDetail} />

                <Route path="/projects/list-answer" name="Answer List" component={AnswerList} />
                <Route path="/projects/answer/:id" name="Answer Detail" component={AnswerDetail} />

                <Route path="/others/slide-shop" name="Answer Detail" component={SlideShop} />

                <Route path="/tutorials" name="Tutorials" component={Tutorials} />
                <Route path="/system-notifications" name="System Notification" component={SystemNotification} />

                <Redirect from="/" to="/dashboard"/>
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js